import React from 'react';
import {
  Flex,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

import { DialogProps } from 'clipsal-cortex-types/src/common/chakra-extension-types';

import {
  ENERGY_MASTERS_CONTACT_US_LINK,
  ENERGY_MASTERS_EMAIL,
  ENERGY_MASTERS_FAQ_LINK,
  ENERGY_MASTERS_PHONE,
} from '../../common/constants';

/**
 * Support contact modal for Energy Masters sites. Non-Energy-Masters sites are directed to the
 * external support page (`CORTEX_SUPPORT_URL`) instead — see `useContactSupport`.
 */
export function SupportModal({ isOpen, onClose }: DialogProps) {
  return (
    <Modal scrollBehavior="inside" isCentered={true} size={'xl'} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent data-testid="support-center-modal-energy-masters" rounded={20} mx={4}>
        <ModalHeader>
          <Flex align={'center'}>Contact Energy Masters Support</Flex>
        </ModalHeader>
        <ModalCloseButton data-testid="support-center-close-btn" />
        <ModalBody pb={6} pt={0}>
          <Text>
            You can reach Energy Masters support by calling{' '}
            <Link
              href={`tel:${ENERGY_MASTERS_PHONE.replace(/\s/g, '')}`}
              style={{ textDecoration: 'none' }}
              color="customBlue.500"
            >
              {ENERGY_MASTERS_PHONE}
            </Link>{' '}
            or emailing{' '}
            <Link href={`mailto:${ENERGY_MASTERS_EMAIL}`} style={{ textDecoration: 'none' }} color="customBlue.500">
              {ENERGY_MASTERS_EMAIL}
            </Link>{' '}
            (9am - 4:30pm Monday to Friday, excluding public holidays).
          </Text>

          <Text mt={4}>
            Your question may also be addressed on the{' '}
            <Link href={ENERGY_MASTERS_CONTACT_US_LINK} style={{ textDecoration: 'none' }} color="customBlue.500">
              Energy Masters website
            </Link>
            . For frequently asked questions about Energy Masters, please refer{' '}
            <Link href={ENERGY_MASTERS_FAQ_LINK} style={{ textDecoration: 'none' }} color="customBlue.500">
              here
            </Link>
            .
          </Text>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
